module.exports = __webpack_public_path__ + "img/Img12b_BgFd-1-7.fafa72ee.jpg";